import { useEffect, useState } from 'react';
import axios from 'axios';
import LightAdmin from 'components/headers/lightAdmin';
import AnimationRevealPage from 'helpers/AnimationRevealPage';
import Footer from "components/footers/FiveColumnWithInputForm.js";
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Swal from 'sweetalert2';
import './style.css';

const UserAdmin = () => {
    const [suppliers, setSuppliers] = useState([]);
    const [isAdmin, setIsAdmin] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [selectedSupplier, setSelectedSupplier] = useState(null);
    const [deviationBonus, setDeviationBonus] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [deletedSuppliers, setDeletedSuppliers] = useState(new Set()); // Track deleted suppliers

    useEffect(() => {
        checkAdminStatus();
    }, []);

    useEffect(() => {
        if (isAdmin) {
            fetchAllSuppliers();
        }
    }, [currentPage, isAdmin]);

    const checkAdminStatus = () => {
        const isAdmin = localStorage.getItem('isAdmin') === '1';
        setIsAdmin(isAdmin);
        if (isAdmin) {
            fetchAllSuppliers();
        } else {
            console.error('Unauthorized: User is not an admin');
        }
    };

    const fetchAllSuppliers = async () => {
        try {
            const token = localStorage.getItem('authToken');
            if (!token) {
                console.error('JWT token not found in local storage');
                return;
            }

            const response = await axios.get(`https://hbmdijital.online/api/admin/suppliers?page=${currentPage}`, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            });

            if (response.status === 200) {
                setSuppliers(response.data.data); // Suppliers data
                setTotalPages(response.data.last_page); // Total pages from API response
            } else {
                console.error('Failed to fetch suppliers:', response.statusText);
            }
        } catch (error) {
            console.error('Error fetching suppliers:', error);
        }
    };
    const handleEditDeviationBonus = (supplier) => {
        setSelectedSupplier(supplier);
        setDeviationBonus(0); // Reset input field
        setShowModal(true);
    };

    const handleSaveDeviationBonus = async () => {
        if (!selectedSupplier) return;

        try {
            const token = localStorage.getItem('authToken');
            const response = await axios.put(
                `https://hbmdijital.online/api/admin/users/${selectedSupplier.id}/deviation-bonus`,
                { deviation_bonus: parseFloat(deviationBonus) },
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (response.status === 200) {
                Swal.fire("Success", "Bonus de déviation mis à jour avec succès !", "success");
                setShowModal(false);
                fetchAllSuppliers();
            } else {
                Swal.fire("Error", "Échec de la mise à jour du bonus de déviation", "error");
            }
        } catch (error) {
            Swal.fire("Error", error.response?.data || "Something went wrong", "error");
        }
    };
    const banUser = async (supplierId) => {
        try {
            const token = localStorage.getItem('authToken');
            const response = await axios.delete(
                `https://hbmdijital.online/api/admin/user/${supplierId}`,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (response.status === 200) {
                // Update the deletedSuppliers state to include the deleted supplier ID
                setDeletedSuppliers((prev) => new Set(prev.add(supplierId)));
                Swal.fire("Success", "Utilisateur supprim� avec succ�s!", "success");
                fetchAllSuppliers(); // Refresh the supplier list
            } else {
                Swal.fire("Error", "�chec de la suppression", "error");
            }
        } catch (error) {
            Swal.fire("Error", error.response?.data || "Something went wrong", "error");
            fetchAllSuppliers(); // Refresh supplier list in case of error
        }
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    if (!isAdmin) {
        return <p className="text-danger text-center">Unauthorized: You do not have admin access.</p>;
    }

    return (
        <AnimationRevealPage>
            <LightAdmin />
            <div className="d-flex flex-column flex-md-row">
                <section className="w-100 p-3">
                    <div className="d-flex justify-content-start align-items-center gap-2">
                        <h1 className="text-dark display-4">Les Utilisateurs</h1>
                    </div>
                    <hr className="my-4" />

                    {/* Suppliers Table */}
                    <div className="table-responsive">
                        <table className="table table-striped table-hover">
                            <thead className="table-primary">
                                <tr>
                                    <th>ID</th>
                                    <th>Nom</th>
                                    <th>Email</th>
                                    <th>Téléphone</th>
                                    <th>Adresse</th>
                                    <th>Grade</th>
                                    <th>Gains</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                           <tbody>
    {suppliers.map((supplier) => (
        <tr key={supplier.id}>
            <td>{supplier.custom_id}</td>
            <td>{supplier.name}</td>
            <td>{supplier.email}</td>
            <td>{supplier.phone}</td>
            <td>{supplier.address}</td>
            <td>{supplier.grade}</td>
            <td>{supplier.gainsUser}</td>
            <td>
                <button
                    className="btn btn-warning"
                    disabled={supplier.is_deleted} // Disable the button if the user is deleted

                    onClick={() => handleEditDeviationBonus(supplier)}
                >
                    Modifier
                </button>

                <button
                    className="btn btn-danger"
                    onClick={() => banUser(supplier.id)}
                    disabled={supplier.is_deleted} // Disable the button if the user is deleted
                >
                    Ban
                </button>
            </td>
        </tr>
    ))}
</tbody>
                        </table>
                    </div>

                    {/* Pagination Controls */}
                    <div className="d-flex justify-content-center">
                        <nav>
                            <ul className="pagination">
                                <li className="page-item" onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>
                                    <button className="page-link">Previous</button>
                                </li>
                                {[...Array(totalPages)].map((_, index) => (
                                    <li key={index} className={`page-item ${currentPage === index + 1 ? 'active' : ''}`}>
                                        <button className="page-link" onClick={() => handlePageChange(index + 1)}>
                                            {index + 1}
                                        </button>
                                    </li>
                                ))}
                                <li className="page-item" onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>
                                    <button className="page-link">Next</button>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </section>
            </div>

            {/* Modal for Editing Deviation Bonus */}
            <Modal show={showModal} onHide={() => setShowModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Modifier le bonus de Devotion pour {selectedSupplier?.name}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="form-group">
                        <label htmlFor="deviationBonus">Entrez le nouveau bonus de Devotion:</label>
                        <input
                            type="number"
                            className="form-control"
                            id="deviationBonus"
                            value={deviationBonus}
                            onChange={(e) => setDeviationBonus(e.target.value)}
                            placeholder="Enter amount"
                        />
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModal(false)}>
                        Fermer
                    </Button>
                    <Button variant="primary" onClick={handleSaveDeviationBonus}>
                        Enregistrer les modifications
                    </Button>
                </Modal.Footer>
            </Modal>

            <Footer />
        </AnimationRevealPage>
    );
};

export default UserAdmin;
